import { City, State } from 'country-state-city';

export const getStateByCity = (cityName: string, countryCode: string) =>
  State.getStateByCodeAndCountry(
    City.getCitiesOfCountry(countryCode)?.find((city) => city.name === cityName)
      ?.stateCode ?? '',
    countryCode,
  );
